import { slotsData } from "./slots.data";

export const SlotGames = {
  // ChilliHeat: {
  //   href: "/casino/worldcasino/ChilliHeat",
  //   code: "vs25chilli",
  //   casino: "wco",
  //   provider: "PP",
  //   homeUrl: "",
  //   cover: { src: "./images/slots/chilli-head.png", alt: "" },
  // },
  // BiggerBass: {
  //   href: "/casino/worldcasino/BiggerBass",
  //   code: "vs10bbbonanza",
  //   casino: "wco",
  //   provider: "PP",
  //   homeUrl: "",
  //   cover: { src: "./images/slots/biggerbass.png", alt: "" },
  // },
  // fortunegiza: {
  //   href: "/casino/worldcasino/fortunegiza",
  //   code: "vs20amuleteg",
  //   casino: "ezugi",
  //   provider: "",
  //   homeUrl: "",
  //   cover: { src: "./images/slots/fortunegiza.png", alt: "" },
  // },
  // sweetbonanza: {
  //   href: "/casino/wco/sweetbonanza",
  //   code: "1101",
  //   casino: "wco",
  //   provider: "PP",
  //   homeUrl: "",
  //   cover: { src: "./images/slots/sweetbonanza.png", alt: "" },
  // },
  // sweetbonanza: {
  //   href: "/casino/evolution/sweetbonanza",
  //   code: "1",
  //   casino: "wco",
  //   provider: "XPG",
  //   homeUrl: "",
  //   cover: { src: "./images/roulette/casino033.png", alt: "" },
  // },
  // sweetbonanza: {
  //   href: "/casino/worldcasino/sweetbonanza",
  //   code: "vs20fruitsw",
  //   casino: "wco",
  //   provider: "PP",
  //   homeUrl: "",
  //   cover: { src: "./images/slots/sweetbonanza.png", alt: "" },
  // },
  // sweetbonanzaxmas: {
  //   href: "/casino/worldcasino/sweetbonanzaxmas",
  //   code: "vs20sbxmas",
  //   casino: "wco",
  //   provider: "PP",
  //   homeUrl: "",
  //   cover: { src: "./images/slots/sweetbonanzaxmas.png", alt: "" },
  // },
  // lionways: {
  //   href: "/casino/worldcasino/lionways",
  //   code: "vs243lionsgold",
  //   casino: "wco",
  //   provider: "PP",
  //   homeUrl: "",
  //   cover: { src: "./images/slots/lionmegaways.png", alt: "" },
  // },
};

export const WordCasinoGames = {
  ...slotsData.wazdan,
  
};
